import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevron = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 12,
	viewBox: "0 0 8 12",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Chevron" }), /* @__PURE__ */ _jsx("path", { d: "M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z" })]
});
export default SvgChevron;
